import { createRoot } from 'react-dom/client'
import App from 'app/App'
import Site from 'site/Site'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createConsumer } from '@rails/actioncable'
import OpenWith from 'native/OpenWith'

// Detect if we're in Cordova or app subdomain
window.isCordova = window.cordova !== undefined
window.isAppSubdomain = window.location.hostname.split('.')[0] === 'app'
window.isBrowserApp = !isCordova && isAppSubdomain

const queryClient = new QueryClient()
const consumer = createConsumer(`ws://localhost:3000/cable`)

const Root = ({ Inner }) => {
  useEffect(() => {
    const subscription = consumer.subscriptions.create('UserChannel', {
      connected() {},
      received(data) {
        const event = new CustomEvent(data.event, { detail: data })
        document.dispatchEvent(event)
        console.log('data.event', data.event)
      }
    })

    return () => {
      subscription.unsubscribe() // Clean up on unmount
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Inner />
    </QueryClientProvider>
  )
}

// Load the appropriate component
const Inner = isCordova || isAppSubdomain ? App : Site
window.mountReact = () => {
  OpenWith.setup()

  const root = createRoot(document.getElementById('app-wrapper'))
  root.render(<Root Inner={Inner} />)
}

const createNotificationChannel = () => {
  cordova.plugins.notification.local.createChannel(
    {
      id: 'dodo_channel',
      name: 'Dodo Timer',
      androidChannelImportance: 4
    },
    () => {
      console.log('Channel created')
    }
  )
}

if (isCordova) {
  document.addEventListener('deviceready', mountReact)
  document.addEventListener('deviceready', createNotificationChannel)
} else {
  document.addEventListener('DOMContentLoaded', mountReact)
}
